import { filterUnique } from 'fe-common'
import comp from '../comp.json'

export function getCompObj(path, type) {
  let result = comp[process.env.COMP_ID][type] || {}
  let paths = path
    .split('/')
    .filter(filterUnique)
    .map(path => (path === '' ? 'index' : path))
  if (paths.length > 1) {
    paths = paths.slice(1)
  }
  // console.log('paths:', paths)
  let match = false
  paths.forEach(path => {
    if (result.hasOwnProperty(path)) {
      result = result[path]
      match = true
    }
  })
  return {
    match,
    result
  }
}

export function getTitle(path, locale) {
  const h1 = getCompObj(path, 'h1')
  // console.log('h1:', h1)

  let title
  if (h1.match) {
    title = h1.result[locale]
  } else {
    const head = getCompObj(path, 'head')
    // console.log('head:', head)

    title = head.result.title[locale]
  }

  // console.log('title:', title)
  return title
}

export default function({ store, route }) {
  const title = getTitle(route.path, store.state.locale)

  if (title) {
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!process.server) {
      store.commit('headerModule/TITLE', title)
    } else {
      if (store.state.headerModule.setTitleIntervalId) {
        clearInterval(store.state.headerModule.setTitleIntervalId)
        store.commit('headerModule/SET_TITLE_INTERVAL_ID', null)
      }
      store.commit(
        'headerModule/SET_TITLE_INTERVAL_ID',
        setInterval(() => {
          if (store.state.isPageLoaded) {
            store.commit('headerModule/TITLE', title)

            clearInterval(store.state.headerModule.setTitleIntervalId)
            store.commit('headerModule/SET_TITLE_INTERVAL_ID', null)
          }
        }, 100)
      )
    }
  }
}
